import { actions, screens } from "../conf/tags_ga.conf";

class TagService {
  constructor(head) {
    this.head = head || window.head;
    this.actions = actions;
    this.screens = screens;
  }

  /**
   * Send data to Google Analytics.
   *
   * @param {string} category - The category of the data.
   * @param {string} action - The action being processed.
   * @param {string} label - The label corresponding to the action.
   * @param {Object} extra - Extra data.
   */
  sendEvent(category, action, label, extra) {
    if (typeof window.o_link === "function") {
      try {
        window.o_link(category, action, label, extra || {});
      } catch (error) {
        // Silent
      }
    } else if (this.head) {
      this.head.ready(() => {
        window.o_link(category, action, label, extra || {});
      });
    }
  }

  /**
   * Call the Orange common element method to set a page view on different analytics tools
   * @param {Object.<string>} trackObj - Screen data
   * @param {bool} nonInteraction - Use to avoid a wrong bounce rate when the screen is non interactive
   * @param {string[]} uidArray - Specify some tags with their uid
   * @returns {*}
   */
  sendPageView(trackObj, nonInteraction, uidArray) {
    if (typeof window.o_view === "function") {
      try {
        window.o_view(trackObj, nonInteraction, uidArray);
      } catch (error) {
        // Silent
      }
    } else if (this.head) {
      this.head.ready(() => {
        window.o_view(trackObj, nonInteraction, uidArray);
      });
    }
  }

  /**
   * Send information to Google Analytics that a screen has been displayed
   *
   * @param {string} screen - Identifier of the screen being displayed
   * @param {bool} nonInteraction - Use to avoid a wrong bounce rate when the screen is non interactive
   */
  sendScreen(screen, nonInteraction) {
    if (!this.screens[screen]) {
      return;
    }
    this.sendPageView(this.screens[screen], nonInteraction || false);
  }

  /**
   * Send informations to Google Analytics about the action being processed.
   *
   * @param {string} action - Identifier of the action being processed.
   */
  sendAction(action) {
    if (!this.actions[action]) {
      return;
    }
    this.sendEvent(
      this.actions[action].category,
      this.actions[action].action,
      this.actions[action].label
    );
  }

  /**
   * Set new data layer for Tealium
   * @param {String} layer
   * @param {*} value
   */
  setDataLayer(layer, value) {
    window.o_data[layer] = value;
  }
}

export default new TagService();
